/**
 * `/$org/apps/imanage/recent`: see IManageRecentPage.
 *
 * @module routes/$org.apps.imanage.recent
 */
import { createFileRoute } from "@tanstack/react-router";

import { IManageRecentPage } from "../components/apps/imanage/IManagePages";
import { parseIManageSearch } from "../components/apps/imanage/imanagePaths";

function IManageRecentRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IManageRecentPage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace ?? false })}
    />
  );
}

export const Route = createFileRoute("/$org/apps/imanage/recent")({
  validateSearch: parseIManageSearch,
  component: IManageRecentRoute,
});
